import React from 'react';
import { SEO } from '../components/SEO';
import { ContactForm } from '../components/ContactForm';

export function ContactPage() {
  return (
    <>
      <SEO
        title="Kontakt | KELFAE LOFTER ApS"
        description="Kontakt KELFAE LOFTER ApS. Vejleåvej 1, 2635 Ishøj. Tlf: (+45) 43 71 25 40, E-mail: jlh@kelfae.dk. Har du spørgsmål eller kommentarer?"
      />

      <section className="bg-neutral-100 border-b border-neutral-200 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-xs font-bold uppercase tracking-widest text-neutral-900 bg-[#7FDCA7]/30 px-3 py-1 rounded-full border border-[#7FDCA7]/50 inline-block">
              Find Os & Skriv
            </span>
            <h1 className="text-3xl sm:text-5xl font-extrabold text-neutral-900 font-serif-heading tracking-tight">
              Kontakt os
            </h1>
            <p className="text-sm sm:text-base text-neutral-600 leading-relaxed">
              Har du spørgsmål eller kommentarer til vore produkter eller ønsker du et uforpligtende tilbud?
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            {/* Company Info Box */}
            <div className="lg:col-span-5 space-y-8">
              <div className="bg-neutral-50 border border-neutral-200 p-8 rounded-2xl space-y-6 shadow-sm">
                <h2 className="text-lg font-bold text-neutral-900 font-serif-heading uppercase tracking-wider border-b border-neutral-200 pb-3">
                  Vores informationer
                </h2>

                <div className="space-y-4 text-xs sm:text-sm text-neutral-700">
                  <div>
                    <p className="text-base font-bold text-neutral-900 font-serif-heading">KELFAE LOFTER ApS</p>
                    <p className="text-xs text-neutral-500 mt-0.5">CVR nr.: 19837688</p>
                  </div>

                  <div className="flex items-start gap-3 pt-2">
                    <i className="fa-regular fa-location-dot text-[#7FDCA7] text-base mt-1" aria-hidden="true" />
                    <div>
                      <p className="font-semibold text-neutral-900">Adresse</p>
                      <p className="text-neutral-600">Vejleåvej 1, 2635 Ishøj</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <i className="fa-solid fa-phone text-[#7FDCA7] text-base mt-1" aria-hidden="true" />
                    <div>
                      <p className="font-semibold text-neutral-900">Telefon</p>
                      <a
                        href="tel:43712540"
                        className="text-neutral-900 font-bold hover:text-[#69C892] underline whitespace-nowrap"
                      >
                        (+45) 43 71 25 40
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <i className="fa-regular fa-envelope text-[#7FDCA7] text-base mt-1" aria-hidden="true" />
                    <div>
                      <p className="font-semibold text-neutral-900">E-mail</p>
                      <a
                        href="mailto:jlh@kelfae.dk"
                        className="text-neutral-900 font-bold hover:text-[#69C892] underline whitespace-nowrap"
                      >
                        jlh@kelfae.dk
                      </a>
                    </div>
                  </div>
                </div>

                {/* Pickup Warehouse */}
                <div className="pt-6 border-t border-neutral-200 space-y-2 text-xs">
                  <div className="flex items-center gap-2">
                    <span className="px-2 py-0.5 bg-[#7FDCA7] text-neutral-950 font-bold text-[10px] uppercase rounded">
                      NYT
                    </span>
                    <h3 className="font-bold text-neutral-900 uppercase tracking-wider">
                      Afhentnings lager
                    </h3>
                  </div>
                  <p className="font-semibold text-neutral-800">
                    Thurah Transport A/S (Terminalen)
                  </p>
                  <p className="text-neutral-600">Vejleåvej 1, 2635 Ishøj</p>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="lg:col-span-7 bg-neutral-50 border border-neutral-200 p-8 rounded-2xl shadow-sm">
              <h2 className="text-lg font-bold text-neutral-900 font-serif-heading uppercase tracking-wider border-b border-neutral-200 pb-4 mb-6">
                Send os en besked
              </h2>
              <ContactForm isLight={true} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
